import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB38bPUaAmJqPB1vJICE_lYd0LALcmY-9I',
        libraries: 'places',
    },
    installComponents: true
})